<script setup>
import UnderMaintenance from '@/views/under-maintenance.vue';
definePage({ 
  meta: { public: true, },
})
</script>
<template>
  <UnderMaintenance />
</template>
